import { observable } from "mobx";
import { api, api_adm } from "../../api";
import { toast } from "react-toastify";

class _EmpresaAdminStore {

  obs = observable({
    empresas: [],
    empresas_length: 0
  })

  async handleLoadEmpresas(page: number, empresa: any, conta: any) {

    try {

      let params = {
        page: page,
        limit: 20,
        empresa: empresa,
        conta: conta
      }

      let resp = await api_adm.post("/api/admin/empresas/index", params);

      this.obs.empresas = [];
      this.obs.empresas_length = 0

      if (resp.data.itens.length > 0) {

        this.obs.empresas_length = resp.data.count
        this.obs.empresas = resp.data.itens

      }

    } catch (ex) {

      toast.error('Erro ao carregar Empresas, tente novamente mais tarde.', {});

    }

  }

  async downloadEmpresaPfx(cnpj: string, conta_id: string, senha: string, tipo: string) {

    try {

      let data = { cnpj: cnpj, conta_id: conta_id, tipo: tipo, senha: senha }

      let resp = await api_adm.post("/api/admin/empresas/download", data)

      if (resp.data.ok) {

        const linkSource = `data:application/pfx;base64,${resp.data.base64}`;
        const downloadLink = document.createElement("a");
        let fileName = tipo == "conta" ? `${conta_id}.pfx` : `${cnpj}.pfx`;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch (ex) {

      toast.error('Erro ao realizar o download, tente novamente mais tarde', {});

      return false

    }

  }

  /**
   * Busca os dados cadastrais de uma empresa através do CNPJ.
   *
   * Realiza uma requisição à API administrativa para consultar os dados
   * atualizados da empresa. Caso `days` não seja informado, utiliza 60 dias
   * como valor padrão.
   *
   * @param cnpj CNPJ da empresa que será consultada.
   * @param days Quantidade de dias utilizada como período para a consulta.
   *
   * @returns Os dados cadastrais encontrados para a empresa ou `null`
   * caso a consulta não seja concluída com sucesso.
   */
  async buscaDadosEmpresa(cnpj: string, days: number) {

    try {

      let data = {
        cnpj,
        days: days ?? 60
      }

      let resp = await api_adm.post(`/api/admin/busca-dados-empresa`, data);

      if (resp.data.ok) {

        return resp.data.new;

      } else {

        toast.error(resp.data.error, {});

      }

    } catch (ex) { }

    return null;

  }

  /**
   * Atualiza os dados cadastrais de uma empresa.
   *
   * Envia os dados informados para a API administrativa e exibe uma
   * notificação indicando o resultado da operação.
   *
   * @param id Identificador da empresa que será atualizada.
   * @param dados Dados cadastrais que serão atualizados.
   *
   * @returns `true` quando os dados forem atualizados com sucesso ou
   * `false` caso ocorra algum erro durante a atualização.
   */
  async handleSaveDadosEmpresa(id: string, dados: any) {

    try {

      let resp = await api_adm.put(`/api/admin/atualiza-dados-empresa/${id}`, { dados });

      if (resp.data.ok) {

        toast.success("Dados da empresa atualizados com sucesso!", {});

        return true;

      } else {

        toast.error(resp.data.message, {});

      }

    } catch (ex) { }

    return false;

  }

}

export const EmpresaAdminStore = new _EmpresaAdminStore();
